import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of, map } from 'rxjs';

import {
  EarlyPayRequestsService,
  EPP_REQUESTS_PAGE_NAME,
  EPP_WELCOME_PAGE_NAME,
} from '../../early-pay-requests/early-pay-requests.service';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class SubToSubReferralInvitesGuard {
  private router = inject(Router);
  private userService = inject(UserService);
  private earlyPayRequestsService = inject(EarlyPayRequestsService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const currentUser = this.userService.getUser();
    const isSc = !currentUser.is_company_gc && currentUser.company_type === 'contractor';

    if (
      isSc &&
      !currentUser.visited_pages.includes(EPP_REQUESTS_PAGE_NAME) &&
      !currentUser.visited_pages.includes(EPP_WELCOME_PAGE_NAME)
    ) {
      return this.earlyPayRequestsService.getReferralHistory({ as_invited_only: true }).pipe(
        map((referralHistory) => {
          if (referralHistory.results.length > 0) {
            this.router.navigate(['early-pay', 'welcome']);
            return false;
          }
          return true;
        }),
      );
    }
    return of(true);
  }
}
